import React from 'react'

import { useDispatch } from 'react-redux'
import { SET_REDIRECT } from '@redux/actions/types'

import { useParams } from 'react-router-dom'

import { Button } from '@omnilert/components'

import useStyle from './big-action-button.style'

const BigActionButton = ({ data }) => {
  const { action, meta, title } = data

  const classes = useStyle()

  const { personalAccessCode } = useParams()

  const dispatch = useDispatch()

  const handleOnClick = () => {
    switch (action) {
    case 'joinPriorityConnect':
      dispatch({
        type: SET_REDIRECT,
        payload: `/${personalAccessCode}/priority-connect/${meta?.conferenceAlias}`
      })

      break
    default:
      break
    }
  }

  return (
    <div className={classes.container}>
      <Button
        className={classes.button}
        onClick={handleOnClick}
        title={title}
        variant='solid'
      />
    </div>
  )
}

export default BigActionButton
